import React from 'react'

export const MovieListHeading = (props) => {
  return (
    <div className='col '>
        <h1>{props.heading}</h1>
    </div>
  )
}
